/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c6f5be3f874bae0de12da82562871182d644bc3a";
